import React, { useState, useEffect } from 'react';
// import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  IconButton,
  InputAdornment,
  styled,
  ThemeProvider,
  createTheme
} from '@mui/material';
import {
  Visibility,
  VisibilityOff,
  Person,
  Email,
  Phone,
  Lock
} from '@mui/icons-material';
import Loader from "./circularProgress";
import { Snackbar, Alert } from '@mui/material';
// Custom styled components
const StyledCard = styled(Card)(({ theme }) => ({
  maxWidth: 450,
  margin: '0 auto',
  padding: theme.spacing(2),
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
  borderRadius: 12,
}));

const FormTextField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2.5),
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderRadius: 8,
    },
    '&:hover fieldset': {
      borderColor: theme.palette.primary.main,
    },
  },
}));

// Create custom theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#2563eb',
    },
    secondary: {
      main: '#64748b',
    },
  },
  typography: {
    h5: {
      fontWeight: 600,
    },
    body2: {
      color: '#64748b',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 24px',
          textTransform: 'none',
          fontSize: '1rem',
        },
      },
    },
  },
});


const SignupForm = ({ onCreateAccount }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    mobile: '',
  });
  
  const [formErrors, setFormErrors] = useState({
    name: '',
    email: '',
    password: '',
    mobile: ''
  });
  
  const [showPassword, setShowPassword] = useState(false);
  const [formValid, setFormValid] = useState(false);
  // const [isOtpSent, setIsOtpSent] = useState(false);
  // const [isOtpVerified, setIsOtpVerified] = useState(false);
  // const [otp, setOtp] = useState('');
  // const [generatedOtp, setGeneratedOtp] = useState(null);
  const [isSubmit, setIsSubmit] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  //  const [severity, setSeverity] = useState('success'); // success, error, warning, info
  //  const [message, setMessage] = useState('');
  //  const [open,setOpen] = useState(false);
   const navigate = useNavigate();

  // console.log("message: ", message)
  // console.log("severity: ", severity)

  const validateField = (name, value) => {
    let errorMessage = '';
    
    const validators = {
      name: () => {
        if (!value.trim()) return 'Name is required';
        if (value.trim().length <= 3) return 'Name must be more than 3 letters';
        return '';
      },
      email: () => {
        if (!value.trim()) return 'Email is required';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'Please enter a valid email address';
        return '';
      },
      password: () => {
        if (!value) return 'Password is required';
        if (value.length < 6 || !/[A-Z]/.test(value) || !/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
          return 'Password must be at least 6 characters with 1 uppercase letter and 1 special character';
        }
        return '';
      },
      mobile: () => {
        if (!value.trim()) return 'Mobile number is required';
        if (!/^[6-9]\d{9}$/.test(value)) return 'Please enter a valid 10-digit mobile number';
        return '';
      }
    };

    errorMessage = validators[name]?.() || '';
    
    setFormErrors(prev => ({ ...prev, [name]: errorMessage }));
    // validateForm();
  };

  useEffect(() => {
    const isValid = Object.values(formErrors).every(error => !error) &&
                    Object.values(formData).every(value => value !== '') &&
                    formErrors.mobile === "";
    setFormValid(isValid);
  }, [formData, formErrors]);

  

  const handleChange = (evt) => {
    const { name, value } = evt.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    validateField(name, value);
  };

  // const sendOtp = () => {
  //   if (formValid) {
  //     const generated = Math.floor(100000 + Math.random() * 900000);
  //     setGeneratedOtp(generated);
  //     console.log(`OTP sent: ${generated}`);
  //     setIsOtpSent(true);
  //   }
  // };

  // const verifyOtp = () => {
  //   if (otp === generatedOtp?.toString()) {
  //     setIsOtpVerified(true);
  //     alert('OTP Verified Successfully!');
  //   } else {
  //     alert('Invalid OTP. Please try again.');
  //   }
  // };
  // const handleClose = () => {
  //   setOpen(false);
  // }
  const API_URL = process.env.REACT_APP_BASE_URL;
  const handleSubmit = async (evt) => {
    evt.preventDefault();
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.error || 'Something went wrong!');
      }
      setIsLoading(false);
      alert(data.message);
      // setMessage(data.message)
      // setSeverity('success');
      // setOpen(true)
      setIsSubmit(true);
      navigate("/login")
    } catch (error) {
      setIsLoading(false);
      alert(error.message);
      // setMessage(error.message)
      // setSeverity('error');
      // setOpen(false);
    } 
    
  };

  

  return (
    <ThemeProvider theme={theme}>
      <StyledCard>
        <CardContent>
        <div style={{position: 'relative'}}>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      <Typography variant="h5" gutterBottom>
        Create an Account
      </Typography>
      <Typography variant="body2" sx={{ mb: 3 }}>
        Enter your details to sign up
      </Typography>

      <FormTextField
        fullWidth
        label="Name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        onBlur={() => validateField('name', formData.name)}
        error={!!formErrors.name}
        helperText={formErrors.name}
        disabled={isSubmit}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Person color="action" />
            </InputAdornment>
          ),
        }}
      />

      <FormTextField
        fullWidth
        label="Email"
        name="email"
        type="email"
        value={formData.email}
        onChange={handleChange}
        onBlur={() => validateField('email', formData.email)}
        error={!!formErrors.email}
        helperText={formErrors.email}
        disabled={isSubmit}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Email color="action" />
            </InputAdornment>
          ),
        }}
      />

      <FormTextField
        fullWidth
        label="Password"
        name="password"
        type={showPassword ? 'text' : 'password'}
        value={formData.password}
        onChange={handleChange}
        onBlur={() => validateField('password', formData.password)}
        error={!!formErrors.password}
        helperText={formErrors.password}
        disabled={isSubmit}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Lock color="action" />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowPassword(!showPassword)}
                edge="end"
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <FormTextField
        fullWidth
        label="Mobile Number"
        name="mobile"
        value={formData.mobile}
        onChange={handleChange}
        onBlur={() => validateField('mobile', formData.mobile)}
        error={!!formErrors.mobile}
        helperText={formErrors.mobile}
        disabled={isSubmit}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Phone color="action" />
            </InputAdornment>
          ),
        }}
      />

      {/* {!isOtpSent ? (
        <Button
          fullWidth
          variant="contained"
          onClick={sendOtp}
          disabled={!formValid}
          size="large"
          sx={{ mb: 2 }}
        >
          Send OTP
        </Button>
      ) : null}

      
      {isOtpVerified && (
        <Button
        fullWidth
        variant="contained"
        type="submit"
        size="large"
        onClick={() => setIsSubmit(true)}
        sx={{
          mb: 2,
          animation: isOtpVerified && !isSubmit ? "pulse 1.5s infinite" : "none",
          "@keyframes pulse": {
            "0%": { transform: "scale(1)" },
            "50%": { transform: "scale(1.1)" },
            "100%": { transform: "scale(1)" },
          },
        }}
      >
        Create Account
      </Button>
      
      )} */}

          <Button
              fullWidth
              variant="contained"
              type="submit"
              size="large"
              disabled={!formValid || isSubmit}
              sx={{ mb: 2 }}
            >
              Create Account
            </Button>

            {isLoading && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(255, 255, 255, 0.6)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1,
                  }}
                >
                  <Loader/>
                </Box>
              )}

        <Typography variant="body2" align="center">
        Already have an account?{' '}
        <Button
          component={Link}
          to="/login"
          color="primary"
          onClick={onCreateAccount}
          sx={{ textTransform: 'none' }}
        >
          Login here
        </Button>
      </Typography>
    </Box>
    </div>
        </CardContent>
      </StyledCard>

      {/* <Snackbar
        open={open}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar> */}
    </ThemeProvider>
  );
};

export default SignupForm;